module.exports = __webpack_public_path__ + "img/Jennifer Fidler.759ea7c3.jpg";